import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styleData from "./myDebts.module.css";

import MainContent from "../../../layouts/maincontent/MainContent";

import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import disputeInfo from "../../../assets/img/Icon feather-file-text.png";
// import walletAdd from "../../../assets/img/Wallet-pana.png";

import { useLocation } from "react-router-dom";
import { get, post, remove } from "../../../adapters/xhr/api";
import Claims from "../claims";
import DebtSupportingDocuments from "./DebtSupportDocuments";
import MyDebtClaims from "../my-debt-claims";
import { PaginationTax } from "../../../shared/pagination/Pagination";
import Modal from "react-modal";
import stylesModal from "../../../components/UnifiedTaxDeclaration/forms/formTypes/Modal.module.css";

const MyDebts = () => {
  Modal.setAppElement("body");

  const [isLoading, setIsLoading] = useState(false);
  const [units, setUnits] = useState([]);
  const [wallet, setWallet] = useState(0);
  const [showFiles, setShowFiles] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [idToBeDeleted, setIdToBeDeleted] = useState(null);

  const [isSubmitButtonActive, setIsSubmitButtonActive] = useState(false);
  const [activeTab, setActiveTab] = useState("payments");
  const [unitId, setUnitId] = useState(0);
  const [declarationStatus, setDeclarationStatus] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [isAmountMissing, setIsAmountMissing] = useState(false);

  const [limit, setLimit] = useState(100);
  const [pagination, setPagination] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [error, setError] = useState(null);

  useEffect(() => {
    if (location?.state?.activeTab) {
      setActiveTab(location?.state?.activeTab);
    }
  }, [location]);

  // TO DO:
  // Change this API endpoint to the correct one when available
  const getMyDebtUnitList = async (page = 1, newLimit, isFirstLoad = false) => {
    try {
      const perPage = newLimit || limit;

      // Build URL conditionally
      let url = `api/declaration-system/my-debts/unit?page=${page}`;
      if (!isFirstLoad) {
        url += `&per_page=${perPage}`;
      }

      const response = await get(url);
      setUnits(response?.data?.data);
      setPagination(response?.data?.meta);
      setLimit(response?.data?.meta?.per_page);
      setDeclarationStatus(parseInt(response?.data?.declaration_status_id));
      setWallet(response?.data?.wallet_balance);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeTab === "payments") {
      getMyDebtUnitList(1, limit, true); // first load → skip per_page
    }
  }, [activeTab, showFiles]);

  const handlePageChange = (page) => {
    getMyDebtUnitList(page, limit);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    getMyDebtUnitList(1, newLimit);
  };

  useEffect(() => {
    const checkedUnits =
      units?.filter(
        (unit) => unit?.is_checked,
        // &&unit?.is_exist_in_claim === false
      ) || [];
    setIsSubmitButtonActive(
      checkedUnits.length > 0 &&
        checkedUnits.every((unit) => unit?.amount && Number(unit?.amount) > 0),
    );
  }, [units]);

  const handleShowFiles = (element) => {
    setShowFiles(true);
    setUnitId(element?.id);
    setDocuments(
      element?.attachments ||
        element?.debt_supporting_document ||
        element?.my_debt_supporting_documents ||
        [],
    );
  };

  const handleDeleteClick = (element) => {
    setIdToBeDeleted(element?.id);
    setShowDeleteModal(true);
  };

  const handleEditClick = (element) => {
    navigate(`/my-debts/create-payment-request/${element?.id}`, {
      state: { wallet },
    });
  };

  const handleDeleteUnit = async () => {
    try {
      if (idToBeDeleted) {
        await remove(`api/declaration-system/my-debts/unit/${idToBeDeleted}`);
        getMyDebtUnitList(1, limit);
      }
    } catch (error) {
      console.log("failed to delete unit");
    } finally {
      setShowDeleteModal(false);
      setIdToBeDeleted(null);
    }
  };

  const handleNavigateToCreateRequest = () => {
    const targetPath = `/my-debts/create-payment-request`;

    navigate(targetPath, {
      state: {
        wallet,
      },
    });
  };

  const data =
    units?.length > 0 &&
    units?.map((element, index) => (
      <tr
        key={`${element?.id}-${element?.type}-${index}`}
        className={` ${element?.is_exist_in_claim && "opacity-50"}`}
      >
        <td data-label="نوع العقار">{element?.property_type_name || "-"}</td>
        <td data-label="المحافظة">{element?.governorate_name || "-"}</td>
        <td data-label="عنوان العقار">{element?.address || "-"}</td>
        <td data-label="رقم العقار">{element?.feature_number || "-"}</td>
        <td data-label="رقم الدور">
          {element?.floor || element?.other_floor_number || "-"}
        </td>
        <td data-label="رقم الوحدة">{element?.unit_number || "-"}</td>
        <td data-label="سبب السداد">
          {element?.payment_reason_name || element?.other_payment_reason || "-"}
        </td>{" "}
        <td data-label="*المبلغ المطلوب سداده">
          <input
            type="text"
            value={element?.debt_payment_amount ?? ""}
            className="p-2 rounded"
            style={{
              backgroundColor: "#F5F5F5",
              border: "1px solid #CFCFCF",
              width: `${(element?.debt_payment_amount?.toString().length || 1) + 2}ch`,
            }}
            placeholder="0"
            inputMode="decimal"
            disabled={!element?.is_checked}
          />
        </td>
        <td data-label="المبلغ الجاري سداده">
          <span
            className="p-2 rounded"
            style={{ backgroundColor: "#F5F5F5", border: "1px solid #CFCFCF" }}
          >
            {element?.required_amount ?? "0"}
          </span>
        </td>
        <td data-label="المبلغ المسدد">
          <span
            className="p-2 rounded"
            style={{ backgroundColor: "#F5F5F5", border: "1px solid #CFCFCF" }}
          >
            {element?.paid_amount ?? "0"}
          </span>
        </td>
        <td data-label="مستندات دالة على المديونية">
          <button
            onClick={() => handleShowFiles(element)}
            style={{ backgroundColor: "transparent", border: "0px" }}
          >
            <img
              src={disputeInfo}
              className="img-fluid w-8 h-8"
              alt="عرض المستندات"
            />
          </button>
        </td>
        {/* edit and delete btn */}
        {element?.can_edit && (
          <td data-label="إجراءات">
            <div className={`${styleData["action-buttons"]} `}>
              <button
                className={`${styleData["btn-edit"]}`}
                title="تعديل"
                onClick={() => handleEditClick(element)}
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>

              <button
                className={styleData["btn-delete"]}
                title="حذف"
                onClick={() => handleDeleteClick(element)}
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          </td>
        )}
      </tr>
    ));

  return (
    <MainContent>
      <Modal
        isOpen={showDeleteModal}
        onRequestClose={() => setShowDeleteModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5> هل أنت متأكد من حذف هذا العقار؟</h5>
          <div className="d-flex gap-4 justify-content-center">
            <button className="btn btn-primary px-3" onClick={handleDeleteUnit}>
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowDeleteModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {showFiles ? (
            <section className={`${styleData.listData}`}>
              <DebtSupportingDocuments
                setShowFiles={setShowFiles}
                unitId={unitId}
                setUnits={setUnits}
                documents={documents}
                declarationStatus={declarationStatus}
                declarationId={id}
                readOnly
              />
            </section>
          ) : (
            <section className={`${styleData.listData}`}>
              <div className="container pt-4">
                <div className={styleData.box}>
                  {isAmountMissing && (
                    <div
                      className="alert alert-danger mt-3"
                      id="amount_error"
                      role="alert"
                    >
                      يجب ادخال المبلغ المطلوب سداده
                    </div>
                  )}
                  <div className={`${styleData["box-header"]}`}>
                    <div className="d-flex align-items-center flex-wrap">
                      <button
                        className={`${styleData["btn-arrow"]} ms-3`}
                        onClick={() => navigate("/")}
                      >
                        <i className="fa-solid fa-arrow-right mt-1"></i>
                      </button>

                      {/* Responsive Tabs */}
                      <div className={`ms-2 ${styleData["tabs-wrapper"]}`}>
                        <div
                          className={`${styleData["tab-item"]} ${
                            activeTab === "payments" ? styleData["active"] : ""
                          }`}
                          onClick={() => setActiveTab("payments")}
                        >
                          <h3 className="mb-0 ms-2 fw-bold">
                            قائمة بالوحدات التي تم إنشاء طلب سداد عنها{" "}
                          </h3>
                        </div>

                        <div
                          className={`${styleData["tab-item"]} ${
                            activeTab === "claims" ? styleData["active"] : ""
                          }`}
                          onClick={() => setActiveTab("claims")}
                        >
                          <h3 className="mb-0 ms-2 fw-bold">طلبات السداد</h3>
                        </div>
                      </div>
                    </div>

                    {activeTab === "payments" && (
                      <div>
                        {declarationStatus !== 1 && (
                          <button
                            className={`${styleData["btn-request"]}`}
                            id="add_declaration_button"
                            onClick={handleNavigateToCreateRequest}
                          >
                            إنشاء طلب سداد عن عقار
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  {location?.state?.message && (
                    <div className="alert alert-danger mt-2 text-center w-25 mx-auto">
                      <h3 className="fs-5">{location?.state?.message} </h3>
                    </div>
                  )}

                  <div>
                    {activeTab === "payments" && (
                      <>
                        <div className={`${styleData["box-body"]}  mt-3`}>
                          <div
                            className={`${styleData["table-responsive"]} table-responsive `}
                          >
                            <table className={`${styleData["table"]} table`}>
                              <thead>
                                <tr>
                                  {/* <th scope="col"></th> */}
                                  <th scope="col">نوع العقار</th>
                                  <th scope="col">المحافظة</th>
                                  <th scope="col">عنوان العقار</th>
                                  <th scope="col">رقم العقار</th>
                                  <th scope="col">رقم الدور</th>
                                  <th scope="col">رقم الوحدة</th>
                                  <th scope="col">سبب السداد</th>{" "}
                                  {/* Added reason for payment column */}
                                  <th scope="col">المبلغ المطلوب سداده</th>
                                  <th scope="col">المبلغ الجاري سداده</th>
                                  <th scope="col">المبلغ المسدد</th>
                                  <th scope="col">
                                    مستندات دالة على المديونية
                                  </th>
                                  <th scope="col">إجراءات</th>
                                </tr>
                              </thead>

                              <tbody>
                                {data?.length > 0 ? (
                                  data
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={10}
                                      className="h5 text-center text-secondary"
                                    >
                                      لا توجد عقارات مضافة لإنشاء طلب سداد
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          {pagination && (
                            <PaginationTax
                              limit={limit}
                              count={pagination?.total}
                              active={pagination?.current_page}
                              callback={handlePageChange}
                              handleLimitChange={handleLimitChange}
                            />
                          )}
                        </div>
                      </>
                    )}

                    {activeTab === "claims" && (
                      <>
                        {/* Put your claims tab content here */}
                        <MyDebtClaims />
                        {/* <div className="text-center text-muted py-4">
                            <h5>لا توجد طلبات سداد حالياً</h5>
                          </div> */}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
        </>
      )}
    </MainContent>
  );
};

export default MyDebts;
